import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b082bd9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row settings-content-inner settings-content-inner-agents" }
const _hoisted_2 = { class: "column settings-content-inner-column" }
const _hoisted_3 = {
  class: "settings-content-box",
  style: {"margin":"24px 0 32px"}
}
const _hoisted_4 = { class: "setting-content-box-title row ibf-h2" }
const _hoisted_5 = { class: "setting-content-box-title-left ibf-oneline1" }
const _hoisted_6 = { class: "setting-content-box-input input-width" }
const _hoisted_7 = {
  class: "row settings-content-box",
  style: {"gap":"80px"}
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "setting-content-box-title row ibf-h2" }
const _hoisted_10 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_11 = { class: "setting-content-box-input input-width" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "setting-content-box-title row ibf-h2" }
const _hoisted_14 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_15 = { class: "setting-content-box-input input-width" }
const _hoisted_16 = { class: "setting-content-box" }
const _hoisted_17 = {
  class: "setting-content-box-title row",
  style: {"margin-bottom":"14px"}
}
const _hoisted_18 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_19 = { class: "helper-slider" }
const _hoisted_20 = { class: "setting-content-box-subtitle row ibf-text-list3" }
const _hoisted_21 = { class: "setting-content-box-title-right brand_almost_black ibf-oneline4" }
const _hoisted_22 = { class: "setting-content-box-input" }
const _hoisted_23 = { class: "settings-content-processes" }
const _hoisted_24 = { class: "setting-content-box-input-checkbox ignore-those-process-checkbox-container" }
const _hoisted_25 = { class: "setting-content-box-input-checkbox" }
const _hoisted_26 = {
  key: 0,
  class: "settings-content-processes-box"
}
const _hoisted_27 = {
  key: 0,
  class: "settings-content-processes-process-headerbox"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-content-processes-process-title" }, "Processes", -1))
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "process-title" }
const _hoisted_31 = {
  class: "row settings-content-box",
  style: {"align-items":"baseline"}
}
const _hoisted_32 = { class: "cache-clean-content" }
const _hoisted_33 = {
  class: "setting-content-box-input input-width cache-time-period ibf-oneline1",
  style: {"margin-left":"12px"}
}
const _hoisted_34 = { class: "row settings-content-box" }
const _hoisted_35 = { class: "cache-clean-content" }
const _hoisted_36 = { class: "column settings-content-inner-column" }
const _hoisted_37 = { class: "setting-content-box-title" }
const _hoisted_38 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_39 = { class: "row settings-content-box" }
const _hoisted_40 = { class: "settings-content-box-inabox" }
const _hoisted_41 = { class: "setting-content-box-title row" }
const _hoisted_42 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_43 = { class: "setting-content-box-subtitle row ibf-text-list3" }
const _hoisted_44 = { class: "helper-slider" }
const _hoisted_45 = { class: "setting-content-box-subtitle row" }
const _hoisted_46 = { class: "setting-content-box-title-right brand_almost_black ibf-oneline4" }
const _hoisted_47 = {
  key: 0,
  class: "settings-content-box-inabox",
  style: {"margin-bottom":"32px"},
  "data-testid": "settings-agents--release-offline-agents-block"
}
const _hoisted_48 = { class: "setting-content-box-title row" }
const _hoisted_49 = { class: "setting-content-box-title-left ibf-h7" }
const _hoisted_50 = {
  class: "setting-content-box-subtitle row ibf-text-list3",
  style: {"max-width":"90%"}
}
const _hoisted_51 = { class: "setting-content-box-input" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = {
  key: 1,
  class: "row setting-content-box-input-checkbox"
}
const _hoisted_54 = { class: "setting-content-box-title row ibf-h7" }
const _hoisted_55 = { class: "setting-content-box-subtitle row ibf-text-list3" }
const _hoisted_56 = {
  class: "row settings-content-box",
  style: {"align-items":"baseline","max-width":"190px"}
}
const _hoisted_57 = { class: "cache-clean-content" }
const _hoisted_58 = {
  class: "setting-content-box-input input-width cache-time-period ibf-oneline1",
  style: {"margin-left":"24px","margin-top":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_incredi_input_num_with_menu = _resolveComponent("incredi-input-num-with-menu")!
  const _component_slider = _resolveComponent("slider")!
  const _component_incredi_check_box = _resolveComponent("incredi-check-box")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_settings_item_box = _resolveComponent("settings-item-box")!
  const _component_settings_default_agent_license = _resolveComponent("settings-default-agent-license")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_tooltip_btn = _resolveComponent("tooltip-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_settings_item_box, {
        header: _ctx.$t('settings.agents.helperAssignment.title'),
        subtitle: _ctx.$t('settings.agents.helperAssignment.subtitle')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('settings.agents.diskSpace.title')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_incredi_input_num_with_menu, {
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                "default-option": _ctx.inputsWithMenuSelectedOption['disk-space-component'],
                value: _ctx.objectPath.get(_ctx.settingsObject, _ctx.QUERY_RESULT_PATH.settings.windows.agent.minDiskFree),
                filter: 'disksize',
                class: "row",
                "menu-options": ['MB', 'GB'],
                placeholder: "0",
                "id-name": "disk-space-component",
                "data-testid": _ctx.elementsIds.settings.form.windows.agents.diskSpace,
                "input-width": "78",
                "menu-min-width": "64",
                onOptionSelected: _ctx.handleInputWithMenuSelection,
                onInputChange: _cache[0] || (_cache[0] = 
                (newVal, sizeType) => {
                  _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.minDiskFree, _ctx.util.convertSizeToMB(newVal, sizeType) < 1024 ? 1024 : _ctx.util.convertSizeToMB(newVal, sizeType));
                }
              )
              }, null, 8, ["disable", "default-option", "value", "data-testid", "onOptionSelected"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('settings.agents.memory.virtual.title')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_incredi_input_num_with_menu, {
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                  "default-option": _ctx.inputsWithMenuSelectedOption['min-virtual-memory-component'],
                  class: "row",
                  value: _ctx.settingsObject?.settings?.windows?.agent?.minVirtualMemory,
                  filter: 'disksize',
                  "menu-options": ['MB', 'GB'],
                  placeholder: "0",
                  "id-name": "min-virtual-memory-component",
                  "data-testid": _ctx.elementsIds.settings.form.windows.agents.virtualMemory,
                  "input-width": "78",
                  "menu-min-width": "64",
                  onOptionSelected: _ctx.handleInputWithMenuSelection,
                  onInputChange: _cache[1] || (_cache[1] = 
                  (newVal, sizeType) => {
                    const res = _ctx.util.convertSizeToMB(newVal, sizeType);
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.minVirtualMemory, _ctx.util.convertSizeToMB(newVal, sizeType));
                    // inputsData.MinVirtualMem = util.convertSizeToMB(newVal, sizeType);
                  }
                )
                }, null, 8, ["disable", "default-option", "value", "data-testid", "onOptionSelected"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('settings.agents.memory.physical.title')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_incredi_input_num_with_menu, {
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                  "default-option": _ctx.inputsWithMenuSelectedOption['min-physical-memory-component'],
                  class: "row",
                  value: _ctx.settingsObject?.settings?.windows?.agent?.minPhysicalMemory,
                  filter: 'disksize',
                  "menu-options": ['MB', 'GB'],
                  placeholder: "0",
                  "id-name": "min-physical-memory-component",
                  "data-testid": _ctx.elementsIds.settings.form.windows.agents.physicalMemory,
                  "input-width": "78",
                  "menu-min-width": "64",
                  onOptionSelected: _ctx.handleInputWithMenuSelection,
                  onInputChange: _cache[2] || (_cache[2] = 
                  (newVal, sizeType) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.minPhysicalMemory, _ctx.util.convertSizeToMB(newVal, sizeType));
                    // inputsData.MinPhysicalMem = util.convertSizeToMB(newVal, sizeType);
                  }
                )
                }, null, 8, ["disable", "default-option", "value", "data-testid", "onOptionSelected"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('settings.agents.coreLimit.title')), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(Math.round(_ctx.settingsObject?.settings?.windows?.agent?.minIdleLevel || 0)) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_slider, {
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                  value: _ctx.settingsObject.settings?.windows?.agent?.minIdleLevel,
                  "min-value": 10,
                  "max-value": 100,
                  "label-value": "%",
                  "id-name": "cpu-available-slider",
                  onInput: _cache[3] || (_cache[3] = (val) => _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.minIdleLevel, +val))
                }, null, 8, ["disable", "value"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_incredi_check_box, {
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                  "label-for": "checkbox-ignore-cpu-processes",
                  label: _ctx.$t('settings.agents.helperAssignment.ignoreCpuProcess.text'),
                  value: _ctx.ignoreCpuProcess,
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleIgnoreProcesses()))
                }, null, 8, ["disable", "label", "value"])
              ])
            ]),
            (_ctx.ignoreCpuProcess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.processToAdd,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.processToAdd) = $event)),
                      disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                      class: "incredi-input setting-border-box addprocess-input ibf-text-list3",
                      placeholder: "Add process",
                      for: "ignore-cpu-process-input"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                          name: "add",
                          class: "refresh-icon make-me-click",
                          onClick: _ctx.addProcess
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disable"])
                  ]),
                  (_ctx.ignoredProcessesList && _ctx.ignoredProcessesList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_q_scroll_area, {
                          style: {"height":"170px"},
                          "thumb-style": { borderRadius: '3px', width: '6px', background: '#49DEAC', right: '0px', opacity: '1' }
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ignoredProcessesList.split(','), (app) => {
                              return (_openBlock(), _createElementBlock("div", { key: app }, [
                                _createElementVNode("div", {
                                  id: `ignored-process-app-${app}`,
                                  class: "row",
                                  style: {"padding-right":"18px"}
                                }, [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(app), 1),
                                  (_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 0,
                                        name: "clear",
                                        class: "to-the-right process-clear make-me-click",
                                        onClick: ($event: any) => (_ctx.removeProcess(app))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_29)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["header", "subtitle"]),
      _createVNode(_component_settings_item_box, {
        "data-testid": "settings-agents--helper-cache-license-block",
        header: _ctx.$t('settings.agents.LastCacheCleared.title'),
        subtitle: _ctx.$t('settings.agents.LastCacheCleared.subtitle')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_incredi_check_box, {
                "data-testid": "settings-agents--helper-cache-license-checkbox",
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                value: _ctx.settingsObject?.settings?.windows?.agent?.runCacheCleanup,
                "label-for": "checkbox-cache-schedule-cleanup",
                label: _ctx.$t('settings.agents.LastCacheCleared.RunCacheCleanup.text'),
                "onUpdate:value": _cache[6] || (_cache[6] = 
                (val) => {
                  _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.runCacheCleanup, val);
                }
              )
              }, null, 8, ["disable", "value", "label"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_incredi_input_num_with_menu, {
                "data-testid": _ctx.elementsIds.settings.form.windows.agents.scheduleCleanupInput,
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents || !_ctx.settingsObject?.settings?.windows?.agent?.runCacheCleanup,
                "default-option": _ctx.inputsWithMenuSelectedOption['time-period-space-component'],
                mask: "######'",
                value: _ctx.settingsObject?.settings?.windows?.agent?.cacheCleanupInterval,
                filter: 'timePeriod',
                class: "hover-shadow incredi-text-transform-lowercase",
                "menu-options": ['DAYS'],
                placeholder: "1",
                "id-name": "time-period-space-component",
                "input-width": "40",
                "menu-min-width": "50",
                onOptionSelected: _ctx.handleInputWithMenuSelection,
                onInputChange: _cache[7] || (_cache[7] = (newVal, selectedOption) => _ctx.handleInputIntervalChange(newVal, selectedOption, _ctx.QUERY_RESULT_PATH.settings.windows.agent.cacheCleanupInterval, 1, 999))
              }, null, 8, ["data-testid", "disable", "default-option", "value", "onOptionSelected"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header", "subtitle"]),
      _createVNode(_component_settings_item_box, {
        style: {"white-space":"pre-line"},
        header: _ctx.$t('settings.agents.agentHelperPermissions.title'),
        subtitle: _ctx.$t('settings.agents.agentHelperPermissions.subtitle'),
        "data-testid": "settings-agents--agent-helper-permissions-block"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_incredi_check_box, {
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                value: !!_ctx.settingsObject?.settings?.windows?.agent?.allowEnableDisableAsHelper,
                "label-for": "checkbox-agent-helper-permissions",
                label: _ctx.$t('settings.agents.agentHelperPermissions.labelText'),
                "onUpdate:value": _cache[8] || (_cache[8] = 
                (val) => {
                  _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.allowEnableDisableAsHelper, val);
                }
              )
              }, null, 8, ["disable", "value", "label"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header", "subtitle"])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_settings_item_box, {
        header: _ctx.$t('settings.agents.license.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('settings.agents.defaultAgentLicense.title')), 1),
            _createVNode(_component_settings_default_agent_license, {
              style: {"margin-top":"12px"},
              "data-testid": "settings-agents--default-agent-license-block",
              disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
              "model-value": _ctx.settingsObject
            }, null, 8, ["disable", "model-value"])
          ]),
          _createVNode(_component_q_separator, {
            class: "separator-class",
            style: {"width":"100% !important","margin-bottom":"24px"}
          }),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('settings.agents.cpuHelperCoresRegistration.title')), 1)
              ]),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('settings.agents.cpuHelperCoresRegistration.subtitle')), 1),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.settingsObject?.settings?.windows?.license?.helperCoresAssignmentPercentage) + "%", 1)
                ]),
                _createVNode(_component_slider, {
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                  markers: "",
                  value: _ctx.settingsObject?.settings?.windows?.license?.helperCoresAssignmentPercentage,
                  "min-value": 10,
                  "max-value": 100,
                  steps: "5",
                  "label-value": "%",
                  "id-name": "cpu-helper-core-slider",
                  onInput: _cache[9] || (_cache[9] = 
                  (val) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.license.helperCoresAssignmentPercentage, val);
                  }
                )
                }, null, 8, ["disable", "value"])
              ])
            ]),
            (_ctx.license?.windows?.summary?.totalFloatingInitiators || _ctx.license?.windows?.summary?.totalFloatingCIInitiators)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('settings.agents.license.subtitle')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.agents.license.helperText')), 1),
                    _createVNode(_component_tooltip_btn, {
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"4px"},
                      "tooltip-title": _ctx.$t('settings.agents.license.placeholder')
                    }, null, 8, ["tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_incredi_input_num_with_menu, {
                        disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                        "default-option": _ctx.inputsWithMenuSelectedOption['floating-release-time-component'],
                        value: _ctx.settingsObject?.settings?.windows?.license?.floatingReleaseTime,
                        filter: 'timeForm',
                        "min-value": 60,
                        class: "heartbeat-sizing row hover-shadow incredi-text-transform-lowercase",
                        "menu-options": ['SEC'],
                        mask: "#######",
                        placeholder: "0",
                        "input-width": "78",
                        "menu-min-width": "64",
                        "id-name": "floating-release-time-component",
                        onOptionSelected: _ctx.handleInputWithMenuSelection,
                        onInputChange: _cache[10] || (_cache[10] = 
                    (newVal, selectedOption) => {
                      newVal = _ctx.util.convertTimeToSEC(newVal, selectedOption);
                      _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.license.floatingReleaseTime, newVal);
                    }
                  )
                      }, null, 8, ["disable", "default-option", "value", "onOptionSelected"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isBuildAvoidanceLicensed(_ctx.license?.windows?.summary))
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('settings.agents.buildAvoidnace.title')), 1),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('settings.agents.buildAvoidnace.subtitle')), 1),
                  _createVNode(_component_incredi_check_box, {
                    disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                    value: _ctx.settingsObject?.settings?.windows?.license?.automaticBuildCacheLicense,
                    "label-for": "checkbox-ignore-firewall",
                    label: _ctx.$t('settings.agents.buildAvoidnace.automaticAllocate.text'),
                    "onUpdate:value": _cache[11] || (_cache[11] = 
                (val) => {
                  _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.license.automaticBuildCacheLicense, val);

                }
              )
                  }, null, 8, ["disable", "value", "label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_settings_item_box, {
        style: {"white-space":"pre-line"},
        header: _ctx.$t('settings.agents.removeFloatingOfflineAgents.title'),
        subtitle: _ctx.$t('settings.agents.removeFloatingOfflineAgents.subtitle'),
        "data-testid": "settings-agents--agent-helper-permissions-block"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createVNode(_component_incredi_check_box, {
                "data-testid": "settings-agents--remove-offline-agents-checkbox",
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents,
                value: _ctx.settingsObject?.settings?.windows?.agent?.showOfflineFloatingAgents,
                label: _ctx.$t('settings.agents.removeFloatingOfflineAgents.removeAgents.text'),
                "onUpdate:value": _cache[12] || (_cache[12] = 
                (val) => {
                  _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.showOfflineFloatingAgents, val);
                }
              )
              }, null, 8, ["disable", "value", "label"])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_incredi_input_num_with_menu, {
                "data-testid": "settings-agents--remove-offline-agents-input",
                disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.agents || !_ctx.settingsObject?.settings?.windows?.agent?.showOfflineFloatingAgents,
                "default-option": _ctx.inputsWithMenuSelectedOption['offline-agents-component'],
                mask: "####",
                value: _ctx.settingsObject?.settings?.windows?.agent?.offlineFloatingAgentsPeriod,
                filter: 'timePeriod',
                class: "hover-shadow incredi-text-transform-lowercase",
                "menu-options": ['DAYS'],
                placeholder: "14",
                "id-name": "offline-agents-component",
                "input-width": "152",
                "menu-min-width": "50",
                "max-value": 60,
                "min-value": 1,
                "input-hint": _ctx.$t('settings.agents.removeFloatingOfflineAgents.removeAgents.hint'),
                onOptionSelected: _ctx.handleInputWithMenuSelection,
                onInputChange: _cache[13] || (_cache[13] = newVal => _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.offlineFloatingAgentsPeriod, newVal))
              }, null, 8, ["disable", "default-option", "value", "input-hint", "onOptionSelected"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header", "subtitle"])
    ])
  ]))
}